import tagsSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const tagsActions = { ...actions, ...thunkActions };
export * as TagsTypes from './types';
export default tagsSlice;
